export default __webpack_public_path__ + "static/media/Blue Lagoon.60058ec2.jpg";